<template>
  <div>
    <h1>{{ get("header-1")}}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12" xl="12" lg="12" md="12" sm="12">
            <p>
              {{ get("p-1.1") }}
            </p>
          </v-col>
          <v-col cols="12" xl="12" lg="12" md="12" sm="12">
            <v-img :src="image" class="image"></v-img>
          </v-col>
        </v-row>
        <v-row :class="theme + '-alt-background-1'">
          <v-col cols="12">
            <ol>
              <li>
                <p>
                  {{ get("p-1.2")}}
                </p>
              </li>
              <li>
                <p>
                  {{ get("p-1.3") }}
                </p>
              </li>
              <li>
                <p>
                  {{ get("p-1.4") }}
                </p>
              </li>
              <li>
                <p>
                  {{ get("p-1.5") }}
                </p>
              </li>
              <li>
                <p>
                  {{ get("p-1.6") }}
                </p>
              </li>
              <li>
                <p>
                  {{ get("p-1.7") }}
                </p>
              </li>
            </ol>
            <p>
              {{ get("p-1.8") }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>{{ get("header-2") }}</h2>
            <p>
              {{ get("p-2.1") }}
            </p>
            <p>
              <linkto :text="company" to="/"></linkto> 
              {{ get("p-2.2") }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>
              {{ get("header-3") }}
            </h2>
            <p>
              {{ get("p-3.1") }}  {{ get("company") }} {{ get("p-3.2") }}<phonenumber phone="(719) 390-7663"></phonenumber> 
              {{ get("p-3.3") }}
              <linkto :text="contact" to="/contact"></linkto> 
              {{ get("p-3.4") }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import estimate from "@/components/controls/estimate-ctrl";
import linkto from "@/components/controls/link-to";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";
export default {
  name: "Roofing-Choose",

  components: {
    estimate,
    linkto,
    phonenumber,
  },

  created() {
    this.pageName = 'roof-choose'
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  data: () => ({
    image: require("@/assets/roof-2.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    getLocalization(){}
  }
};
</script>

<style lang="scss" scoped>
</style>
